import { z } from 'zod'

import { getObjectFromHash } from '@/legacy-src/utilities/codingPublicHash'

export enum UserType {
  CLIENT = 0,
  THERAPIST = 1,
}

export const AuthenticatedUserSchema = z.object({
  id: z.number().int().positive(),
  type: z.nativeEnum(UserType),
  email: z.string().email().optional(),
  aiConsent: z.boolean().optional(),
})

export type AuthenticatedUser = z.infer<typeof AuthenticatedUserSchema>

export const LoginLinkParamsSchema = z.object({
  email: z.string().email().optional(),
  redirectUrl: z.string().optional(),
})

export type LoginLinkParams = z.infer<typeof LoginLinkParamsSchema>

// A login link carries its params as one obfuscated blob so the address is not readable in the
// URL. Decode, then validate: a hand-edited or truncated hash must degrade to a plain login
// page rather than break it, hence the catch.
export const LoginLinkHashSchema = z
  .string()
  .optional()
  .transform((hash): unknown => {
    if (!hash) {
      return {}
    }

    try {
      return getObjectFromHash(hash)
    } catch (error) {
      console.error('Malformed login link hash', error)

      return {}
    }
  })
  .pipe(LoginLinkParamsSchema)
  .catch({})

export const LoginSearchParamsSchema = z.object({
  params: LoginLinkHashSchema,
  redirectUrl: z.string().optional(),
})
